import React from 'react';
import bgImage from '../../../assets/servicebanner/Travel-Insurance.webp';

const Breadcrumb = () => {
  return (
    <div className='hero'>
      <img
        src={bgImage}
        alt='breadcrumb background'
        className='hero-img'
      />
      <ul className='breadcumb'>
        <li>Home</li>
        <li>Travel insurance</li>
      </ul>
    </div>
  );
};

export default Breadcrumb;
